import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  donorSignup,
  donorLogin,
  getDonor,
  donorGetResetToken,
  donorResetPassword,
  getTokenDetails,
  donorDeleteAccount,
  ngoLogin,
  getNgo,
  ngoChangePassword,
  getNgoProfile,
  createNgoProfile,
  NgoApply,
  adminLogin,
  donorChangePassword,
  waitlistJoin,
} from "appState/api/auth/auth";

export const createNewDonor = createAsyncThunk(
  "auth/createNewDonor",
  donorSignup
);
export const applyNgo = createAsyncThunk("auth/applyNgo", NgoApply);
export const loginDonor = createAsyncThunk("auth/loginDonor", donorLogin);
export const loginAdmin = createAsyncThunk("auth/loginAdmin", adminLogin);
export const loginNgo = createAsyncThunk("auth/loginNgo", ngoLogin);
export const getCurrentDonor = createAsyncThunk(
  "auth/getCurrentDonor",
  getDonor
);
export const getCurrentNgo = createAsyncThunk("auth/getCurrentNgo", getNgo);
export const getCurrentNgoProfile = createAsyncThunk(
  "auth/getCurrentNgoProfile",
  getNgoProfile
);
export const getDonorResetToken = createAsyncThunk(
  "auth/getDonorResetToken",
  donorGetResetToken
);
export const donorPasswordReset = createAsyncThunk(
  "auth/donorPasswordReset",
  donorResetPassword
);
export const ngoPasswordChange = createAsyncThunk(
  "auth/ngoPasswordChange",
  ngoChangePassword
);
export const donorPasswordChange = createAsyncThunk(
  "auth/donorPasswordChange",
  donorChangePassword
);
export const ngoCreateProfile = createAsyncThunk(
  "auth/ngoCreateProfile",
  createNgoProfile
);
export const getDonorTokenDetails = createAsyncThunk(
  "auth/getDonorTokenDetails",
  getTokenDetails
);
export const deleteDonorAccount = createAsyncThunk(
  "auth/deleteDonorAccount",
  donorDeleteAccount
);
export const joinWaitlist = createAsyncThunk("auth/joinWaitlist", waitlistJoin);

const initialState = {
  isLoading: false,
  isAuthenticated: false,
  token: null,
  refreshToken: null,
  donor: null,
  ngo: null,
  tokenDetails: null,
  ngoProfile: null,
  admin: null,
  isNGO: false,
  isDonor: false,
  isAdmin: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    getToken(state, action) {
      state.token = action.payload.data.token;
      state.refreshToken = action.payload.data.refreshToken;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.ngo = null;
      state.donor = null;
      state.token = null;
      state.isNGO = false;
      state.isDonor = false;
      state.isAdmin = false;
      state.ngoProfile = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createNewDonor.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createNewDonor.fulfilled, (state) => {
      state.isLoading = false;
      state.isDonor = true;
    });
    builder.addCase(createNewDonor.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(applyNgo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(applyNgo.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(applyNgo.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(loginDonor.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loginDonor.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isDonor = true;
      state.donor = action.payload?.data;
    });
    builder.addCase(loginDonor.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(loginAdmin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loginAdmin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isAdmin = true;
      state.admin = action.payload?.data;
    });
    builder.addCase(loginAdmin.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(loginNgo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loginNgo.fulfilled, (state, action) => {
      state.isLoading = false;
      state.ngo = action.payload?.data;
      state.isNGO = true;
    });
    builder.addCase(loginNgo.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCurrentDonor.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCurrentDonor.fulfilled, (state, action) => {
      state.isLoading = false;
      state.donor = action.payload?.data;
    });
    builder.addCase(getCurrentDonor.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCurrentNgo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCurrentNgo.fulfilled, (state, action) => {
      state.isLoading = false;
      state.ngo = action.payload?.data;
    });
    builder.addCase(getCurrentNgo.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCurrentNgoProfile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCurrentNgoProfile.fulfilled, (state, action) => {
      state.isLoading = false;
      state.ngoProfile = action.payload?.data;
    });
    builder.addCase(getCurrentNgoProfile.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getDonorResetToken.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDonorResetToken.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getDonorResetToken.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(donorPasswordReset.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(donorPasswordReset.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(donorPasswordReset.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(ngoPasswordChange.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(ngoPasswordChange.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(ngoPasswordChange.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getDonorTokenDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDonorTokenDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.tokenDetails = action.payload?.data[0];
    });
    builder.addCase(getDonorTokenDetails.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(deleteDonorAccount.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteDonorAccount.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(deleteDonorAccount.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(ngoCreateProfile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(ngoCreateProfile.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(ngoCreateProfile.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(donorPasswordChange.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(donorPasswordChange.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(donorPasswordChange.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(joinWaitlist.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(joinWaitlist.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(joinWaitlist.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const { getToken, logout } = authSlice.actions;

export default authSlice.reducer;
